/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { jsonWebKeySetsGet } from "../funcs/jsonWebKeySetsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { JSONWebKeySet } from "../models/components/jsonwebkeyset.js";
import {
  GetJsonWebKeySetRequest,
  GetJsonWebKeySetSecurity,
} from "../models/operations/getjsonwebkeyset.js";
import { unwrapAsync } from "../types/fp.js";
export type GetJsonWebKeySetQueryData = JSONWebKeySet;

export function prefetchGetJsonWebKeySet(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetJsonWebKeySetRequest,
  security?: GetJsonWebKeySetSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetJsonWebKeySetQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetJsonWebKeySetQuery(
  client$: GramCore,
  request: GetJsonWebKeySetRequest,
  security?: GetJsonWebKeySetSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<GetJsonWebKeySetQueryData>;
} {
  return {
    queryKey: queryKeyGetJsonWebKeySet({
      id: request.id,
      gramSession: request.gramSession,
    }),
    queryFn: async function getJsonWebKeySetQueryFn(
      ctx,
    ): Promise<GetJsonWebKeySetQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(jsonWebKeySetsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetJsonWebKeySet(
  parameters: { id: string; gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "jsonWebKeySets", "get", parameters];
}
